import React from 'react';
import { IAppPropsWithRoute } from '../../../common/types';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { showNavbar } from '../../../store/modules/appStateSlice';
import CalloutRequestedWidget from './CalloutRequestedWidget';


interface CalloutRequestedPageProps extends IAppPropsWithRoute {

};

const CalloutRequestedPage: React.FC<CalloutRequestedPageProps> = (props) =>{
    const dispatch = useDispatch();
    React.useEffect(() => {
        dispatch(showNavbar(false));
    }, [])
    const requestCalloutId =props.match.params.requestCalloutId;
    return <CalloutRequestedWidget requestCalloutId={requestCalloutId}/>;

}

export default withRouter(CalloutRequestedPage);